// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1InMC","file":"styles_file__2QfU0"};